/**
 * @module @repo/global-login-sdk/config
 * Konfigurationsvertrag für die Anbindung einer App an den zentralen Login.
 */

/** Konfiguration, mit der eine App den zentralen `gmolike-id`-Login einbindet. */
export interface GlobalLoginConfig {
  /** URL des zentralen Auth-Projekts (`gmolike-id`), z. B. aus `VITE_SUPABASE_URL`. */
  supabaseUrl: string;
  /** Publishable Key (`sb_publishable_…`) — client-safe. */
  publishableKey: string;
  /** Eindeutiger App-Slug aus `identity.apps.slug`, z. B. `flammenreiter-lore`. */
  appSlug: string;
  /** Basis-URL der zentralen Login-App. Default: `https://auth.gmolike.me`. */
  loginUrl?: string;
  /**
   * Cookie-Domain für das Cross-Subdomain-SSO. Default: `.gmolike.me`.
   * Lokal (localhost/lvh.me) ggf. überschreiben oder leer lassen.
   */
  cookieDomain?: string;
}

/** Default-Basis-URL der zentralen Login-App. */
export const DEFAULT_LOGIN_URL = 'https://auth.gmolike.me';
/** Default-Cookie-Domain für subdomain-weite Sessions. */
export const DEFAULT_COOKIE_DOMAIN = '.gmolike.me';
